export default __webpack_public_path__ + "static/media/video1.4bcbb80d.mp4";